import React, { useState } from "react"
import BudgetManager from "components/Budget/BudgetManager";
import shop from "shop/shop";
import { observer } from "mobx-react";


const CostCentres = observer( () => {
    const { costCentres } = shop.session
    return <div>
      <BudgetManager backLink={"/account"} costCentres={costCentres}/>
    </div>
  }
)
export default CostCentres



// WEBPACK FOOTER //
// ./src/components/CostCentres/CostCentres.js